import { StrategiesPage } from '@/pages/anchor-management/strategy'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
	'/_app/p/anchor-management/anchor-strategy'
)({
	component: StrategiesPage,
})
